import { trackById, trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { TenantLookup } from "src/app/models/tenantLookup.model";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TenantSensor } from "src/app/models/tenantSensor.model";
import { TenantSensorService } from "src/app/services/tenantSensor.service";
import { TenantService } from "src/app/services/tenant.service";
import { ToastService } from "src/app/services/toast.service";
import { DateFormatService } from "src/app/services/dateFormat.service";
import { DeviceVersion } from "src/app/models/deviceVersion.model";
import { DeviceVersionService } from "src/app/services/deviceVersionService";
import { forkJoin } from "rxjs";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { TenantSensorOrgLevelDialogBase } from "../tenantSensorOrgLevelDialog.base";
import { SensorDataTypeEnum } from "src/app/enums/sensorDataType.enum";

export interface EditTenantSensorDialogData {
    id: string;
}

@Component({
  standalone: false,
    selector: "app-edit-tenant-sensor-dialog",
    templateUrl: "editTenantSensorDialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["editTenantSensorDialog.component.scss"],
})
export class EditTenantSensorDialogComponent extends TenantSensorOrgLevelDialogBase implements OnInit {
    isFormLoading = false;
    isLoading = false;
    tenants: TenantLookup[];
    deviceVersions: DeviceVersion[];
    sensor: TenantSensor;
    tableNames = [
        SensorDataTypeEnum.ParticulateTimeseries,
        SensorDataTypeEnum.OpcR2,
        SensorDataTypeEnum.NoiseTimeseries,
        SensorDataTypeEnum.AirNowMonitoring,
        SensorDataTypeEnum.GasData,
    ];

    constructor(
        public dialogRef: MatDialogRef<EditTenantSensorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditTenantSensorDialogData,
        private tenantSensorService: TenantSensorService,
        private tenantService: TenantService,
        private deviceVersionService: DeviceVersionService,
        private dateFormatService: DateFormatService,
        private toastService: ToastService,
        organizationLevelService: OrganizationLevelService,
    ) {
        super(organizationLevelService);
        this.sensor = new TenantSensor();
    }

    ngOnInit() {
        this.isFormLoading = true;
        forkJoin({
            tenants: this.tenantService.getTenantLookupList(),
            deviceVersions:
                this.deviceVersionService.getDeviceVersionLookupList(),
            sensor: this.tenantSensorService.getTenantSensor(this.data.id),
        }).subscribe(
            (result) => {
                this.tenants = result.tenants;
                this.deviceVersions = result.deviceVersions;
                this.sensor = result.sensor;
                if (this.sensor.tenantId) {
                    this.loadOrgLevels(this.sensor.tenantId);
                }
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    public trackById = trackById;
    public trackByIndex = trackByIndex;

    save() {
        const latitude = this.sensor.latitude;
        if (latitude !== undefined && (latitude < -90 || latitude > 90)) {
            this.toastService.showWarning(
                "Latitude must be between -90 and 90.",
                true,
            );
            return;
        }

        const longitude = this.sensor.longitude;
        if (longitude !== undefined && (longitude < -180 || longitude > 180)) {
            this.toastService.showWarning(
                "Longitude must be between -180 and 180.",
                true,
            );
            return;
        }

        this.isLoading = true;
        this.sensor.installDate = this.dateFormatService.formatDateTimeToString(
            this.sensor.installationDate,
            this.dateFormatService.dateToStringWithTimeFormat,
        );
        this.tenantSensorService.updateTenantSensor(this.sensor).subscribe(
            (response) => {
                this.toastService.showSuccess(
                    "Sensor saved successfully",
                    true,
                );
                this.isLoading = false;
                this.dialogRef.close(true);
            },
            (error) => {
                this.toastService.showError(error);
                this.isLoading = false;
            },
        );
    }
}
